import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

export default class TabsContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      withoutContent: false
    }
    this.getLabels = this.getLabels.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.ageKey !== nextProps.ageKey) {
      this.setState({
        activeTab: this.props.content[this.props.defaultActive].label
      })
    } else {
      if (!nextProps.content) {
        this.setState({
          withoutContent: true
        })
      }
    }
  }

  componentWillMount () {
    if (this.props.content) {
      this.setState({
        activeTab: this.props.content[this.props.defaultActive].label
      })
    } else {
      this.setState({
        withoutContent: true
      })
    }
  }
  handleClick (tab) {
    this.setState({activeTab: tab})
  }

  getLabels (type) {
    const result = []
    this.props.content.forEach(element => {
      result.push(element[type])
    })
    return result
  }

  getContent (label) {
    return this.props.content.map(element => {
      if (element.label === label) {
        return <div key={element.label}>{element.content}</div>
      } else {
        return false
      }
    })
  }

  render () {
    if (this.state.withoutContent && !this.props.content) {
      return <div>{this.props.emptyMessage}</div>
    } else {
      return (
        <div>
          <Tabs activeTab={this.state.activeTab} labels={this.getLabels('label')} changeTab={this.handleClick.bind(this)} />
          <div style={{marginTop: '15px'}}>
            {this.getContent(this.state.activeTab)}
          </div>
        </div>
      )
    }
  }
}

TabsContainer.propTypes = {
  emptyMessage: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.object),
  defaultActive: PropTypes.number.isRequired
}

TabsContainer.defaultProps = {
  emptyMessage: 'No Content To Show',
  defaultActive: 0
}

const Tabs = (props) => {
  return (
    <ul className='nav nav-tabs'>
      {props.labels.map(function (tab, index) {
        return (
          <Tab key={index} name={tab} isActive={props.activeTab === tab} handleClick={props.changeTab.bind(this, tab)} />
        )
      }.bind(this))}
    </ul>
  )
}

Tabs.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTab: PropTypes.string.isRequired,
  changeTab: PropTypes.func.isRequired
}

const Tab = (props) => {
  return (
    <li onClick={props.handleClick} className={props.isActive ? 'active' : null}>
      <button>{props.name}</button>
    </li>
  )
}

Tab.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/common/TabsContainer/TabsContainer.js